module.exports = __webpack_public_path__ + "img/ru.13902542.svg";